import maskCurrency from './currency'
import maskDate from './date'
import { isNumber, removeNonDigits } from './util'

export { maskJs, maskCurrency, removeNonDigits, maskDate }

const DIGIT = '9'
const LETTER = 'a'
const ANY = '*'

function isLetter(char: string): boolean {
  return /^[A-Za-z]$/.test(char)
}

function isValidChar(char: string, maskChar: string): boolean {
  if (maskChar === DIGIT) return isNumber(char)
  if (maskChar === LETTER) return isLetter(char)
  if (maskChar === ANY) return isNumber(char) || isLetter(char)
  return false
}

function maskJs(mask: string, value: string = ''): string {
  const inputArray = value.split('')
  const maskArray = mask.split('')
  const maskedValue: string[] = []
  let nextElement = 0

  maskArray.forEach((char, _index) => {
    if ([DIGIT, LETTER, ANY].includes(char)) {
      while (
        nextElement < inputArray?.length &&
        !isValidChar(inputArray[nextElement], char)
      ) {
        nextElement++
      }
      if (
        nextElement < inputArray?.length &&
        isValidChar(inputArray[nextElement], char)
      ) {
        maskedValue.push(inputArray[nextElement])
        nextElement++
      } else {
        return // Pula a inserção do caractere da máscara
      }
    } else {
      if (nextElement < inputArray?.length) {
        maskedValue.push(char)
      }
    }
  })

  return maskedValue.join('')
}
